function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6 .84a10 10 0 000 18.32z",
  fill: "#009246"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14 .84v18.32A10 10 0 0014 .84z",
  fill: "#ce2b37"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14 .84a9.94 9.94 0 00-8 0v18.32a9.94 9.94 0 008 0z",
  fill: "#f0f0f0"
});

function SvgIt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FwYV8xIiBkYXRhLW5hbWU9IkNhcGEgMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjAgMjAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojMDA5MjQ2O30uY2xzLTJ7ZmlsbDojY2UyYjM3O30uY2xzLTN7ZmlsbDojZjBmMGYwO308L3N0eWxlPjwvZGVmcz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik02LC44NEExMCwxMCwwLDAsMCw2LDE5LjE2WiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTE0LC44NFYxOS4xNkExMCwxMCwwLDAsMCwxNCwuODRaIi8+PHBhdGggY2xhc3M9ImNscy0zIiBkPSJNMTQsLjg0YTkuOTQsOS45NCwwLDAsMC04LDBWMTkuMTZhOS45NCw5Ljk0LDAsMCwwLDgsMFoiLz48L3N2Zz4=";
export { SvgIt as ReactComponent };